(() => {
  const ROOT_SELECTOR = '[data-ml-mystery]';

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const setBeamPosition = (stage, clientX, clientY) => {
    const rect = stage.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const x = ((clientX - rect.left) / rect.width) * 100;
    const y = ((clientY - rect.top) / rect.height) * 100;

    stage.style.setProperty('--ml-mystery-x', `${clamp(x, 0, 100).toFixed(2)}%`);
    stage.style.setProperty('--ml-mystery-y', `${clamp(y, 0, 100).toFixed(2)}%`);
    stage.classList.add('is-interacting');
  };

  const setBeamFromElement = (stage, element) => {
    const stageRect = stage.getBoundingClientRect();
    const itemRect = element.getBoundingClientRect();
    if (!stageRect.width || !stageRect.height) return;

    const centerX = itemRect.left + itemRect.width / 2;
    const centerY = itemRect.top + itemRect.height / 2;
    setBeamPosition(stage, centerX, centerY);
  };

  const initMystery = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.mlMysteryBooted === 'true') return;
    const stage = root.querySelector('[data-ml-mystery-stage]');
    if (!(stage instanceof HTMLElement)) return;

    root.dataset.mlMysteryBooted = 'true';

    const onPointerMove = (event) => {
      setBeamPosition(stage, event.clientX, event.clientY);
    };

    const onPointerLeave = () => {
      stage.style.removeProperty('--ml-mystery-x');
      stage.style.removeProperty('--ml-mystery-y');
    };

    const onTouchMove = (event) => {
      const touch = event.touches && event.touches[0];
      if (!touch) return;
      setBeamPosition(stage, touch.clientX, touch.clientY);
    };

    stage.addEventListener('pointerenter', onPointerMove);
    stage.addEventListener('pointermove', onPointerMove);
    stage.addEventListener('pointerleave', onPointerLeave);
    stage.addEventListener('touchstart', onTouchMove, { passive: true });
    stage.addEventListener('touchmove', onTouchMove, { passive: true });

    stage.addEventListener('focusin', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
      const card = target.closest('[data-ml-mystery-card]');
      if (!(card instanceof HTMLElement)) return;
      setBeamFromElement(stage, card);
    });
  };

  const initAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initMystery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    target.querySelectorAll(ROOT_SELECTOR).forEach(initMystery);
    if (target.matches(ROOT_SELECTOR)) initMystery(target);
  });
})();
